export enum ToastType {
  Default = 'success',
  Error = 'error',
  Warning = 'warning'
}